import { mapGetters } from 'vuex';

export default {
  mounted() {
    this.mx_trialPageLoadingTracking();
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
  },
  methods: {
    mx_trialPageLoadingTracking() {
      // TODO: could add new tracking event in future. 2024/01/30
      // this.$tracking.addTrialInteraction(mapProducts(this.getSelectedPlans)); No need the specific product tracking tentatively for now. 
    },
  },
};
